import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";

import { ActivacionOTCellFotosPending } from "@/erp/operaciones/activaciones/instalaciones/shared/components/tables";
import { EstadoLlamadaComponent } from "@/erp/operaciones/instalaciones/shared/components";
import { EstadoOTNewTableCell } from "@/erp/tecnico/shared/components";
import {
  TABLE_CONSTANTS_COLUMS,
  booleanCellValues,
  checkTimePassed,
  emptyCellOneLevel,
  formatCurrency,
  formatDate,
  formatDateWithTimeCell,
  formatHour,
} from "@/shared";
import {
  EstadoComponente,
  ModalObservacionComponente,
} from "@/shared/components/ui";
import { OrdenTrabajo } from "@/shared/interfaces";
import EstadoActivacionComponent from "@/erp/operaciones/instalaciones/shared/components/TableCellComponents/EstadoActivacionComponent";
import dayjs from "dayjs";

export const useColumnsInstalacionesOT = () => {
  ///* columns ==============================
  // base columns -------------
  const columnsOTNewBase01 = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "razon_social",
        header: "Nombre",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          `${row.original.prospecto_data?.razon_social!}_${row.original?.contrato_data?.linea}`,
        // Cell: ({ row }) => cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_data?.razon_social!)
        //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: "observacion_cliente",
        header: "Observacion Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_cliente || "N/A"
            }
          />
        ),
      },
      {
        accessorKey: "identificacion",
        header: "identificacion",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.prospecto_data?.identificacion || "N/A",
      },
      {
        accessorKey: "numero_contrato",
        header: "Núm. Contrato",
        size: 240,
        Cell: ({ row }) =>
          row.original?.contrato_data?.numero_referencia || "N/A",
      },
      {
        accessorKey: "fecha_instalacion",
        header: "Fecha de instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.fecha_instalacion
            ? formatDate(row.original?.agendamiento_data?.fecha_instalacion)
            : row.original?.fecha_instalacion
              ? formatDate(row.original?.fecha_instalacion)
              : "N/A",
        enableColumnFilter: false,
      },
      {
        accessorKey: "hora_instalacion",
        header: "Hora Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.hora_instalacion
            ? formatHour(row.original?.agendamiento_data?.hora_instalacion)
            : row.original?.hora_instalacion
              ? formatHour(row.original?.hora_instalacion)
              : "N/A",
        enableColumnFilter: false,
      },
      {
        accessorKey: "ciudad_nombre",
        header: "Ciudad",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      },
      {
        accessorKey: "direccion",
        header: "Dirección Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.agendamiento_data?.direccion || "N/A",
      },
      {
        accessorKey: "celular",
        header: "Celular Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => emptyCellOneLevel(row, "celular"),
      },
      {
        accessorKey: "celular_2",
        header: "CELULAR 2",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.preventa_data?.celular_2 || "N/A",
      },

      // estado llamada ------------------
      {
        accessorKey: "estado_llamada",
        header: "Estado de llamada",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return row.original?.agendamiento_data?.estado_llamada ? (
            <EstadoLlamadaComponent
              estado={row.original?.agendamiento_data.estado_llamada}
            />
          ) : (
            "N/A"
          );
        },
      },
      {
        accessorKey: "observacion_llamada",
        header: "Observación de llamada",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.agendamiento_data?.observaciones
                ?.observacion_llamada || "N/A"
            }
          />
        ),
      },
      {
        accessorKey: "fecha_aceptacion",
        header: "fecha de aceptación",
        size: 300,
        Cell: ({ row }) =>
          row.original?.preventa_data?.fecha_aceptacion
            ? dayjs(row.original?.preventa_data?.fecha_aceptacion).format(
              "L LT",
            )
            : "N/A",
      },

      //
      {
        accessorKey: "coordenadas",
        header: "COORDENADAS",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.coordenadas || "N/A",
      },
      {
        accessorKey: "email",
        header: "EMAIL",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.preventa_data?.email || "N/A",
      },

      // Persona de referencia ------------------
      {
        accessorKey: "persona_referencia_nombre",
        header: "Persona de referencia",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_nombre || "N/A",
      },
      {
        accessorKey: "persona_referencia_parentesco",
        header: "Parentesco de referencia",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_parentesco || "N/A",
      },
      {
        accessorKey: "persona_referencia_celular",
        header: "Celular de referencia",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_celular || "N/A",
      },
    ],
    [],
  );

  const columnsOTNewEstadoOnlyOT = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "estado_orden_trabajo_exclude",
        header: "Estado Orden Trabajo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.estado_orden_trabajo ? (
            <EstadoOTNewTableCell
              codigo={row.original.estado_orden_trabajo}
              nombre={row.original.estado_orden_trabajo || "N/A"}
            />
          ) : (
            "N/A"
          ),
      },
    ],
    [],
  );
  const columnsOTMotivoRechazoOnly = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "motivo_rechazo",
        header: "Motivo Rechazo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={row.original?.motivo_rechazo || "N/A"}
          />
        ),
      },
      {
        accessorKey: "observacion_rechazo_tecnico",
        header: "Observación Motivo Rechazo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_rechazo_tecnico || "N/A"
            }
          />
        ),
      },
    ],
    [],
  );

  const columnsOTNewBase02 = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      ///* fk ========================================
      // // plan ------------------
      {
        accessorKey: "tipo_plan",
        header: "Tipo Plan",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_plan || "N/A";
        },
      },
      {
        accessorKey: "tipo_servicio",
        header: "Tipo de servicio",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_servicio || "N/A";
        },
      },
      {
        accessorKey: "plan",
        header: "Plan de internet",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || "N/A";
        },
      },
      {
        accessorKey: "velocidad_internet",
        header: "Velocidad de internet",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.velocidad
            ? `${row.original?.preventa_data?.velocidad} ${row.original?.plan_data?.unidad}`
            : "N/A";
        },
      },
      {
        accessorKey: "requiere_contrato_fisico",
        header: "Tipo de contrato",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.requiere_contrato_fisico
            ? "FISICO"
            : "DIGITAL";
        },
      },
      {
        accessorKey: "valor_plan",
        header: "Valor del plan",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_plan
            ? formatCurrency(row.original?.preventa_data?.valor_plan)
            : formatCurrency(0);
        },
      },

      // valor_instalacion_total ------------------
      {
        accessorKey: "valor_instalacion",
        header: "Valor Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion_total
            ? formatCurrency(
              row.original?.preventa_data?.valor_instalacion_total,
            )
            : formatCurrency(0);
        },
      },

      // flota & nap ------------------
      {
        accessorKey: "flota_nombre",
        header: "FLOTA",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.flota_data?.nombre || "N/A",
      },
      {
        accessorKey: "nap_data_nombre",
        header: "NAP",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.nap_data_nombre || "N/A",
      },
      // {
      //   accessorKey: 'distancia',
      //   header: 'DISTANCIA A LA NAP',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
      //   Cell: ({ row }) => emptyCellOneLevel(row, 'distancia'),
      // },
    ],
    [],
  );

  const columsInstalacionTrazabilidad = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      ///* trazabilidad ------------------

      {
        accessorKey: "fecha_creacion",
        header: "Fecha Creación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: true,
        filterVariant: "date",
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_creacion"),
      },
      {
        accessorKey: "fecha_modificacion",
        header: "Fecha Modificación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: true,
        filterVariant: "date",
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_modificacion"),
      },
    ],
    [],
  );

  const columnsOTActivacionData = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "olt",
        header: "OLT",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.olt_data?.nombre || "N/A",
      },
      {
        accessorKey: "ipv_4_actual",
        header: "Dirección IP",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, "ipv_4_actual"),
      },
      // {
      //   accessorKey: 'pppoe',
      //   header: 'PPPoE',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      //   Cell: ({ row }) => emptyCellOneLevel(row, 'pppoe'),
      // },
      // {
      //   accessorKey: 'pppassword',
      //   header: 'PPPassword',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      //   Cell: ({ row }) => emptyCellOneLevel(row, 'pppassword'),
      // },

      {
        accessorKey: "es_router_ac",
        header: "Tiene Router AC",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => booleanCellValues(row, "es_router_ac"),
      },
      {
        accessorKey: "serie_ont",
        header: "Serie ONT",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, "serie_ont"),
      },
    ],
    [],
  );

  const columnsObserservPreventaColums = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "observaciones",
        header: "Observación 1 - Vendedor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.preventa_data?.observaciones?.observacion_1 || "N/A"
            }
          />
        ),
      },
      {
        accessorKey: "observaciones_2",
        header: "Observación 2 - Vendedor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.preventa_data?.observaciones?.observacion_2 || "N/A"
            }
          />
        ),
      },
    ],
    [],
  );

  const columsObservacionActivacionOnlyColum = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      {
        accessorKey: "observacion_activacion",
        header: "Observación Activación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_activacion || "N/A"
            }
          />
        ),
      },
    ],
    [],
  );
  const columsPuertoOnlyActivacion = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "puerto",
        header: "Puerto",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => emptyCellOneLevel(row, "puerto"),
      },
    ],
    [],
  );
  const columnsHoraInitFinActivacion = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "hora_inicio",
        header: "Hora Inicio Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_inicio
            ? formatHour(row.original?.hora_inicio)
            : "N/A",
      },
      {
        accessorKey: "hora_fin",
        header: "Hora Fin Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_fin ? formatHour(row.original?.hora_fin) : "N/A",
      },
    ],
    [],
  );
  const columnsFotoEntrada = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "urls_fotos_entrada",
        header: "Fotos Entrada",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ActivacionOTCellFotosPending
            ordenTrabajo={row.original}
            isReviewingFotosEntrada
          />
        ),
      },
    ],
    [],
  );
  const columnsFotoSalida = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "urls_fotos_salida",
        header: "Fotos Salida",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ActivacionOTCellFotosPending
            ordenTrabajo={row.original}
            isReviewingFotosSalida
          />
        ),
      },
    ],
    [],
  );

  // tables ------------------
  const instalacionesAsignadasTecnicoColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      {
        accessorKey: "fecha_instalacion",
        header: "Fecha de Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        enableColumnFilter: true,
        filterVariant: "date",
        enableSorting: false,
        Cell: ({ row }) => row.original?.fecha_instalacion || "N/A",
      },
      {
        accessorKey: "hora_instalacion",
        header: "Hora Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_instalacion
            ? formatHour(row.original?.hora_instalacion)
            : "N/A",
      },
      {
        accessorKey: "razon_social",
        header: "Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          `${row.original.prospecto_data?.razon_social!}_${row.original?.contrato_data?.linea}`,
        //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      // {
      //   accessorKey: 'vendedor_nombre',
      //   header: 'Vendedor',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      //   Cell: ({ row }) => row.original?.vendedor_data?.razon_social || 'N/A',
      //    //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      // },
      // {
      //   accessorKey: 'canal_venta',
      //   header: 'Canal de Venta',
      //   size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
      //   Cell: ({ row }) => row.original?.prospecto_data?.canal_venta_create || 'N/A',
      // },
      {
        accessorKey: "sector_nombre",
        header: "Sector",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          `${row.original?.sector_data?.nombre} ${row.original?.sector_data?.parroquia ? " / " + row.original?.sector_data?.parroquia : ""}` ||
          "N/A",
      },
      {
        accessorKey: "ciudad_nombre",
        header: "Ciudad",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      },
      {
        accessorKey: "zona_nombre",
        header: "Zona",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.zona_data?.nombre || "N/A",
      },
      {
        accessorKey: "celular",
        header: "Celular Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => emptyCellOneLevel(row, "celular"),
      },

      {
        accessorKey: "persona_referencia_celular",
        header: "Celular de referencia",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_celular || "N/A",
      },
      {
        accessorKey: "plan_data.nombre",
        header: "Plan Contrato",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.plan_data?.nombre || "N/A",
      },
      {
        accessorKey: "tipo_orden_trabajo",
        header: "Tipo Orden de Trabajo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.tipo_orden_trabajo || "N/A",
      },

      ...columnsObserservPreventaColums, //observacion 1 vendedor y observacion 2 vendedor
      {
        accessorKey: "observaciones.observacion_llamada",
        header: "Observación PyL",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.observaciones?.observacion_llamada || "N/A",
      },
      // ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTActivacionData,
      // ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    [],
  );

  const activacionesInstalacionesColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      {
        accessorKey: "razon_social",
        header: "Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          `${row.original.prospecto_data?.razon_social!}_${row.original?.contrato_data?.linea}`,
        // Cell: ({ row }) => `${cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_data?.razon_social!)}_${row.original?.contrato_data?.linea}`
        //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: "identificacion",
        header: "identificación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original.prospecto_data?.identificacion || "N/A",
        //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: "linea",
        header: "Línea",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.prospecto_data?.linea || "N/A",
      },
      {
        accessorKey: "flota_nombre",
        header: "Flota",
        Cell: ({ row }) => row.original?.flota_data?.nombre || "N/A",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      },
      {
        accessorKey: "fecha_instalacion",
        header: "Fecha Instalación",
        enableColumnFilter: false,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.fecha_instalacion ||
          row.original?.fecha_instalacion ||
          "N/A",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      },

      // ...columsInstalacionTrazabilidad,
    ],
    [],
  );
  
  const instalacionesActivacionRealizadaColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columsPuertoOnlyActivacion,
      ...columnsOTActivacionData,
      ...columnsHoraInitFinActivacion,
      ...columnsObserservPreventaColums,
      ...columsObservacionActivacionOnlyColum,
      ...columsInstalacionTrazabilidad,
    ],
    [],
  );

  const pylInstallPrerechazadaPendingColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      ...columnsOTNewBase01,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTMotivoRechazoOnly,
      ...columnsOTNewBase02,
      ...columnsOTActivacionData,
      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    [],
  );

  const instalacionesRealizadasColumns = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "hora_inicio",
        header: "hora inicio",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_inicio
            ? formatHour(row.original?.hora_inicio)
            : "N/A",
      },
      {
        accessorKey: "hora_fin",
        header: "hora fin",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_fin ? formatHour(row.original?.hora_fin) : "N/A",
      },
      {
        accessorKey: "fecha_instalacion",
        header: "Fecha de instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_instalacion
            ? formatDate(row.original?.fecha_instalacion)
            : "N/A",
      },
      {
        accessorKey: "hora_instalacion",
        header: "Hora Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.hora_instalacion ? (
            <EstadoComponente
              backgroundColor={checkTimePassed(
                formatDate(row.original?.fecha_instalacion!),
                row.original?.hora_instalacion,
                row.original.hora_inicio as string,
              )}
              texto={formatHour(row.original?.hora_instalacion) || ""}
            />
          ) : (
            "N/A"
          ),
      },
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    [],
  );

  const instalacionesAsignadasColumns = useMemo<MRT_ColumnDef<OrdenTrabajo>[]>(
    () => [
      {
        accessorKey: "razon_social",
        header: "Nombre",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          `${row.original.prospecto_data?.razon_social!}_${row.original?.contrato_data?.linea}`,
        // Cell: ({ row }) => cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_data?.razon_social!)
        //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      {
        accessorKey: "hora_inicio",
        header: "hora inicio",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_inicio
            ? formatHour(row.original?.hora_inicio)
            : "N/A",
      },
      {
        accessorKey: "hora_fin",
        header: "hora fin",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_fin ? formatHour(row.original?.hora_fin) : "N/A",
      },
      {
        accessorKey: "estado_activacion",
        header: "estado de activación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.estado_activacion ? (
            <EstadoActivacionComponent
              estado={row.original?.estado_activacion.toUpperCase()}
            />
          ) : (
            "N/A"
          );
        },
        // row.original?.estado_activacion
        //   ? row.original?.estado_activacion
        //   : 'N/A',
      },
      {
        accessorKey: "estado_orden_trabajo",
        header: "Estado Orden Trabajo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.estado_orden_trabajo ? (
            <EstadoOTNewTableCell
              codigo={row.original.estado_orden_trabajo}
              nombre={row.original.estado_orden_trabajo || "N/A"}
            />
          ) : (
            "N/A"
          ),
      },
      {
        accessorKey: "fecha_visita",
        header: "Fecha de visita",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_visita
            ? formatDate(row.original?.fecha_visita)
            : "N/A",
      },
      {
        accessorKey: "hora_visita",
        header: "Hora Visita",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.hora_visita ? (
            <EstadoComponente
              backgroundColor={checkTimePassed(
                formatDate(row.original?.fecha_visita!),
                row.original?.hora_visita,
                row.original.hora_inicio as string,
              )}
              texto={formatHour(row.original?.hora_visita) || ""}
            />
          ) : (
            "N/A"
          ),
      },
      // ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    [],
  );

  const instalacionesAsignadasRecoordinadasTecnicoColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTActivacionData,

      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    [],
  );

  const instalacionesPendienteActualizarColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [

      ...columnsOTNewBase01,
      ...columnsOTNewBase02,
      ...columnsOTNewEstadoOnlyOT,
      ...columnsOTActivacionData,

      ...columnsObserservPreventaColums,
      ...columsInstalacionTrazabilidad,
    ],
    [],
  );

  const instalacionesPendienteActualizacionColumns = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      {
        accessorKey: "observacion_actualizacion_tecnico",
        header: "Observación Actualización Técnico",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_actualizacion_tecnico ||
              "N/A"
            }
          />
        ),
      },
      ...instalacionesAsignadasTecnicoColumns,
    ],
    [],
  );

  const columnsHistorialCambiosCoordenadas = useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "usuario",
        header: "usuario",
        size: 300,
      },
      {
        accessorKey: "fecha_cambio",
        header: "fecha_cambio",
        size: 300,
        Cell: ({ row }) =>
          dayjs(row.original?.fecha_cambio).format("DD/MM/YYYY HH:mm:ss"),
      },
      {
        accessorKey: "coordenada_nueva",
        header: "coordenada_nueva",
        size: 300,
        Cell: ({ row }) => (
          <a
            href={`https://www.google.com/maps?q=${row.original?.coordenada_nueva}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {row.original?.coordenada_nueva}
          </a>
        ),
      },
      {
        accessorKey: "coordenada_anterior",
        header: "coordenada_anterior",
        size: 300,
        Cell: ({ row }) => (
          <a
            href={`https://www.google.com/maps?q=${row.original?.coordenada_anterior}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {row.original?.coordenada_anterior}
          </a>
        ),
      },
    ],
    [],
  );
  const columnsVisita = useMemo<Record<string, MRT_ColumnDef<OrdenTrabajo>>>(
   ()=>({
    fecha_visita: {
        accessorKey: "fecha_visita",
        header: "Fecha de visita",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.fecha_visita
            ? formatDate(row.original?.fecha_visita)
            : "N/A",
        enableColumnFilter: false,
      },

      hora_visita: {
        accessorKey: "hora_visita",
        header: "Hora Visita",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.hora_visita
            ? formatHour(row.original?.hora_visita)
            : "N/A",
        enableColumnFilter: false,
      },
   }),[]
  )
  const columnas = useMemo<Record<string, MRT_ColumnDef<OrdenTrabajo>>>(
    () => ({
      fecha_instalacion: {
        accessorKey: "fecha_instalacion",
        header: "Fecha de instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.fecha_instalacion
            ? formatDate(row.original?.agendamiento_data?.fecha_instalacion)
            : row.original?.fecha_instalacion
              ? formatDate(row.original?.fecha_instalacion)
              : "N/A",
        enableColumnFilter: false,
      },

      hora_instalacion: {
        accessorKey: "hora_instalacion",
        header: "Hora Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.hora_instalacion
            ? formatHour(row.original?.agendamiento_data?.hora_instalacion)
            : row.original?.hora_instalacion
              ? formatHour(row.original?.hora_instalacion)
              : "N/A",
        enableColumnFilter: false,
      },
      razon_social: {
        accessorKey: "razon_social",
        header: "Nombre",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          `${row.original.prospecto_data?.razon_social!}_${row.original?.contrato_data?.linea}`,
        // Cell: ({ row }) => cellLineaRazonSocial(row.original?.contrato_data, row.original.prospecto_data?.razon_social!)
        //`${row.original?.prospecto_data?.razon_social} ${row.original?.contrato_data?.linea != 1 ? `- LINEA ${row.original?.contrato_data?.linea}` : ''}` || 'N/A',
      },
      cliente: {
        accessorKey: "razon_social",
        header: "Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          `${row.original.prospecto_data?.razon_social!}_${row.original?.contrato_data?.linea}`,
      },
      observacion_cliente: {
        accessorKey: "observacion_cliente",
        header: "Observacion Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_cliente || "N/A"
            }
          />
        ),
      },
      identificacion: {
        accessorKey: "identificacion",
        header: "identificacion",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.prospecto_data?.identificacion || "N/A",
      },
      numero_contrato: {
        accessorKey: "numero_contrato",
        header: "Núm. Contrato",
        size: 240,
        Cell: ({ row }) =>
          row.original?.contrato_data?.numero_referencia || "N/A",
      },

      ciudad: {
        accessorKey: "ciudad_nombre",
        header: "Ciudad",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.ciudad_data?.nombre || "N/A",
      },
      direccion: {
        accessorKey: "direccion",
        header: "Dirección Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.agendamiento_data?.direccion || "N/A",
      },

      sector: {
        accessorKey: "sector_nombre",
        header: "Sector",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          `${row.original?.sector_data?.nombre ?? ""} ${row.original?.sector_data?.parroquia ? " / " + row.original?.sector_data?.parroquia : ""}`,
      },
      celular: {
        accessorKey: "celular",
        header: "Celular Cliente",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => emptyCellOneLevel(row, "celular"),
      },
      celular_2: {
        accessorKey: "celular_2",
        header: "CELULAR 2",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.preventa_data?.celular_2 || "N/A",
      },
      estado_llamada: {
        accessorKey: "estado_llamada",
        header: "Estado de llamada",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return row.original?.agendamiento_data?.estado_llamada ? (
            <EstadoLlamadaComponent
              estado={row.original?.agendamiento_data.estado_llamada}
            />
          ) : (
            "N/A"
          );
        },
      },
      observacion_llamada: {
        accessorKey: "observacion_llamada",
        header: "Observación de llamada",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.agendamiento_data?.observaciones
                ?.observacion_llamada || "N/A"
            }
          />
        ),
      },
      fecha_aceptacion: {
        accessorKey: "fecha_aceptacion",
        header: "fecha de aceptación",
        size: 300,
        Cell: ({ row }) =>
          row.original?.preventa_data?.fecha_aceptacion
            ? dayjs(row.original?.preventa_data?.fecha_aceptacion).format(
              "L LT",
            )
            : "N/A",
      },
      coordenadas: {
        accessorKey: "coordenadas",
        header: "COORDENADAS",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.agendamiento_data?.coordenadas || "N/A",
      },
      email: {
        accessorKey: "email",
        header: "EMAIL",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.preventa_data?.email || "N/A",
      },
      persona_referencia: {
        accessorKey: "persona_referencia_nombre",
        header: "Persona de referencia",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_nombre || "N/A",
      },
      parentesco_persona_referencia: {
        accessorKey: "persona_referencia_parentesco",
        header: "Parentesco de referencia",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_parentesco || "N/A",
      },
      celular_persona_referencia: {
        accessorKey: "persona_referencia_celular",
        header: "Celular de referencia",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.preventa_data?.persona_referencia_celular || "N/A",
      },

      estado_ot: {
        accessorKey: "estado_orden_trabajo_exclude",
        header: "Estado Orden Trabajo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.estado_orden_trabajo ? (
            <EstadoOTNewTableCell
              codigo={row.original.estado_orden_trabajo}
              nombre={row.original.estado_orden_trabajo || "N/A"}
            />
          ) : (
            "N/A"
          ),
      },
      ///
      motivo_rechazo: {
        accessorKey: "motivo_rechazo",
        header: "Motivo Rechazo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={row.original?.motivo_rechazo || "N/A"}
          />
        ),
      },
      observacion_rechazo_tecnico: {
        accessorKey: "observacion_rechazo_tecnico",
        header: "Observación Motivo Rechazo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.observaciones?.observacion_rechazo_tecnico || "N/A"
            }
          />
        ),
      },
      tipo_plan: {
        accessorKey: "tipo_plan",
        header: "Tipo Plan",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_plan || "N/A";
        },
      },

      tipo_servicio: {
        accessorKey: "tipo_servicio",
        header: "Tipo de servicio",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.tipo_servicio || "N/A";
        },
      },
      plan: {
        accessorKey: "plan",
        header: "Plan de internet",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.plan_data?.nombre || "N/A";
        },
      },

      velocidad_internet: {
        accessorKey: "velocidad_internet",
        header: "Velocidad de internet",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.velocidad
            ? `${row.original?.preventa_data?.velocidad} ${row.original?.plan_data?.unidad}`
            : "N/A";
        },
      },
      tipo_contrato: {
        accessorKey: "requiere_contrato_fisico",
        header: "Tipo de contrato",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.requiere_contrato_fisico
            ? "FISICO"
            : "DIGITAL";
        },
      },
      valor_plan: {
        accessorKey: "valor_plan",
        header: "Valor del plan",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_plan
            ? formatCurrency(row.original?.preventa_data?.valor_plan)
            : formatCurrency(0);
        },
      },
      valor_instalacion: {
        accessorKey: "valor_instalacion",
        header: "Valor Instalación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => {
          return row.original?.preventa_data?.valor_instalacion_total
            ? formatCurrency(
              row.original?.preventa_data?.valor_instalacion_total,
            )
            : formatCurrency(0);
        },
      },
      flota: {
        accessorKey: "flota_nombre",
        header: "FLOTA",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.flota_data?.nombre || "N/A",
      },
      nap: {
        accessorKey: "nap_data_nombre",
        header: "NAP",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.nap_data_nombre || "N/A",
      },

      observacion_1: {
        accessorKey: "observaciones",
        header: "Observación 1 - Vendedor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.preventa_data?.observaciones?.observacion_1 || "N/A"
            }
          />
        ),
      },
      observacion_2: {
        accessorKey: "observaciones_2",
        header: "Observación 2 - Vendedor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => (
          <ModalObservacionComponente
            observacion_cliente={
              row.original?.preventa_data?.observaciones?.observacion_2 || "N/A"
            }
          />
        ),
      },
      olt: {
        accessorKey: "olt",
        header: "OLT",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.olt_data?.nombre || "N/A",
      },

      ip: {
        accessorKey: "ipv_4_actual",
        header: "Dirección IP",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, "ipv_4_actual"),
      },

      router: {
        accessorKey: "es_router_ac",
        header: "Tiene Router AC",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => booleanCellValues(row, "es_router_ac"),
      },
      serie_ont: {
        accessorKey: "serie_ont",
        header: "Serie ONT",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => emptyCellOneLevel(row, "serie_ont"),
      },

      fecha_creacion: {
        accessorKey: "fecha_creacion",
        header: "Fecha Creación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: true,
        filterVariant: "date",
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_creacion"),
      },

      fecha_modificacion: {
        accessorKey: "fecha_modificacion",
        header: "Fecha Modificación",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        enableColumnFilter: true,
        filterVariant: "date",
        enableSorting: false,
        Cell: ({ row }) => formatDateWithTimeCell(row, "fecha_modificacion"),
      },

      tipo_orden_trabajo: {
        accessorKey: "tipo_orden_trabajo",
        header: "Tipo Orden de Trabajo",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => row.original?.tipo_orden_trabajo || "N/A",
      },
      plan_contrato: {
        accessorKey: "plan_data.nombre",
        header: "Plan Contrato",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.plan_data?.nombre || "N/A",
      },
      observacion_pyl: {
        accessorKey: "observaciones.observacion_llamada",
        header: "Observación PyL",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) =>
          row.original?.observaciones?.observacion_llamada || "N/A",
      },
      zona: {
        accessorKey: "zona_nombre",
        header: "Zona",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) => row.original?.zona_data?.nombre || "N/A",
      },
      hora_inicio: {
        accessorKey: "hora_inicio",
        header: "hora inicio",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_inicio
            ? formatHour(row.original?.hora_inicio)
            : "N/A",
      },
      hora_fin: {
        accessorKey: "hora_fin",
        header: "hora fin",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
        Cell: ({ row }) =>
          row.original?.hora_fin ? formatHour(row.original?.hora_fin) : "N/A",
      },
    }),
    [],
  );
  //activaciones-visista 
  const visitaActivacionColumns = useMemo(
    ()=>[
      columnas.cliente,
      columnas.identificacion,
      columnsVisita.fecha_visita,
      columnsVisita.hora_visita

    ],[]
  )
  //visita
  const columnsVisitaTecnico = useMemo(
    ()=>[
      columnsVisita.fecha_visita,
      columnsVisita.hora_visita,
      columnas.cliente ,
      columnas.tipo_contrato,
      columnas.sector,
      columnas.ciudad,
      columnas.zona,
      columnas.celular,
      columnas.celular_persona_referencia,

    ],[]
  )
  const asiganadasTecnicoColumnas = useMemo(
    () => [
      columnas.fecha_instalacion,
      columnas.hora_instalacion,
      columnas.cliente,
      columnas.tipo_contrato,
      columnas.sector,
      columnas.ciudad,
      columnas.zona,
      columnas.celular,
      columnas.celular_persona_referencia,
      columnas.plan_contrato,
      columnas.valor_plan,
      columnas.valor_instalacion,
      columnas.flota,
      columnas.nap,
      columnas.olt,
      columnas.tipo_orden_trabajo,
      columnas.observacion_1,
      columnas.observacion_2,
      columnas.observacion_pyl,
      columnas.tipo_plan,
      columnas.tipo_servicio,
      columnas.plan,
      columnas.velocidad_internet,
      columnas.estado_ot,
      columnas.ip,
      columnas.router,
      columnas.serie_ont,
      columnas.fecha_creacion,
      columnas.fecha_modificacion,
    ],
    [],
  );

  const AsignadasRecoordinadasTecnicoColumns = useMemo(
    () => [
      columnas.fecha_instalacion,
      columnas.hora_instalacion,
      columnas.razon_social,
      columnas.plan,
      columnas.tipo_contrato,
      columnas.valor_plan,
      columnas.valor_instalacion,
      columnas.flota,
      columnas.nap,
      columnas.olt,
      columnas.identificacion,
      columnas.numero_contrato,
      columnas.ciudad,
      columnas.estado_llamada,
      columnas.observacion_llamada,
      columnas.fecha_aceptacion,
      columnas.coordenadas,
      columnas.email,
      columnas.persona_referencia,
      columnas.parentesco_persona_referencia,
      columnas.celular_persona_referencia,
      columnas.tipo_plan,
      columnas.tipo_servicio,
      columnas.velocidad_internet,
      columnas.estado_ot,
      columnas.ip,
      columnas.router,
      columnas.serie_ont,
      columnas.direccion,
      columnas.celular,
      columnas.celular_2,
      columnas.observacion_1,
      columnas.observacion_2,
      columnas.fecha_creacion,
      columnas.fecha_modificacion,
    ],
    [],
  );

  const instalacionesRealizadasTecnicoColumns = useMemo(
    () => [
      columnas.hora_inicio,
      columnas.hora_fin,
      columnas.fecha_instalacion,
      columnas.hora_instalacion,
      columnas.razon_social,
      columnas.sector,
      columnas.ciudad,
      columnas.zona,
      columnas.celular,
      columnas.celular_2,

      columnas.observacion_cliente,
      columnas.identificacion,
      columnas.numero_contrato,
      columnas.direccion,
      columnas.estado_llamada,
      columnas.observacion_llamada,
      columnas.fecha_aceptacion,
      columnas.coordenadas,
      columnas.email,
      columnas.persona_referencia,
      columnas.parentesco_persona_referencia,
      columnas.celular_persona_referencia,

      columnas.tipo_plan,
      columnas.tipo_servicio,
      columnas.plan,
      columnas.velocidad_internet,
      columnas.tipo_contrato,
      columnas.valor_plan,
      columnas.valor_instalacion,
      columnas.flota,
      columnas.nap,
      columnas.observacion_1,
      columnas.observacion_2,
      columnas.observacion_pyl,
      columnas.fecha_creacion,
      columnas.fecha_modificacion,
    ],
    [],
  );

  const instalacionesPendienteActualizarTecnicoColumns = useMemo(
    () => [
      columnas.hora_inicio,                   // hora inicio
      columnas.hora_fin,                      // hora fin
      columnas.fecha_instalacion,             // fecha de instalación
      columnas.hora_instalacion,              // hora instalación
      columnas.razon_social,                  // cliente
      columnas.sector,                        // sector
      columnas.ciudad,                        // ciudad
      columnas.zona,                          // zona
      columnas.celular,                       // celular cliente
      columnas.celular_persona_referencia,    // celular referencia
      columnas.plan_contrato,                 // plan contrato
      columnas.tipo_contrato,                 // tipo contrato
      columnas.valor_plan,                    // valor plan
      columnas.valor_instalacion,             // valor instalación
      columnas.flota,                         // flota
      columnas.nap,                           // nap
      columnas.olt,                           // olt
      columnas.tipo_orden_trabajo,            // tipo orden trabajo
      columnas.observacion_1,                 // observación vendedor
      columnas.observacion_2,                 // observación 2 vendedor
      columnas.observacion_pyl,               // observación PYL
      columnas.tipo_plan,                     // tipo plan
      columnas.tipo_servicio,                 // tipo servicio
      columnas.plan,                          // plan de internet
      columnas.velocidad_internet,            // velocidad de internet
      columnas.estado_ot,                      // estado orden de trabajo
      columnas.ip,                            // dirección IP
      columnas.router,                        // tiene router AC
      columnas.serie_ont,                     // serie ONT
      columnas.direccion,                     // dirección cliente
      columnas.email,                         // email
      columnas.persona_referencia,            // persona referencia
      columnas.parentesco_persona_referencia,// parentesco persona referencia
      columnas.celular_2,                     // celular 2
      columnas.fecha_creacion,                // fecha creación
      columnas.fecha_modificacion,            // fecha modificación
    ],
    [],
  );


  return {
    //dicionario
    asiganadasTecnicoColumnas,
    AsignadasRecoordinadasTecnicoColumns,
    instalacionesRealizadasTecnicoColumns,
    instalacionesPendienteActualizarTecnicoColumns,

    //sin diccionario
    instalacionesAsignadasTecnicoColumns, //.1
    instalacionesActivacionRealizadaColumns,

    instalacionesAsignadasRecoordinadasTecnicoColumns, //.2
    instalacionesPendienteActualizarColumns, //.4

    pylInstallPrerechazadaPendingColumns,
    instalacionesRealizadasColumns, //.3

    instalacionesAsignadasColumns,
    instalacionesPendienteActualizacionColumns,

    activacionesInstalacionesColumns,
    columnsHistorialCambiosCoordenadas,

    //temp
    columnsFotoEntrada,
    columnsFotoSalida,

    columnsVisitaTecnico,
    //visita
    visitaActivacionColumns
  };
};
